import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { CampaignBreakdownResp, SnippetBreakdownResp } from './BaseLevelBreakdownApiTypes';

export type SnipPathToDataMap = { [snipPath: string]: SnippetBreakdownResp };

export type StoredSnippetBreakdowns = { [baseLevelSnipId: string]: SnippetBreakdownResp[] };

export type StoredCampaignBreakdowns = { [baseLevelSnipId: string]: CampaignBreakdownResp[] };

export enum RowTypes {
  Snippet,
  Link,
  Variation,
  Combined, // for nested levels with snippet and links
  Campaign,
}

export enum SnippetsTableModes {
  CampaignAnalytics = 'CAMPAIGN_ANALYTICS',
  MessagingInsights = 'MESSAGING_INSIGHTS',
}

export type SortObj = {
  snippetsSortedBy: string;
  setSnippetsSortedBy: (snippetsSortedBy: string) => void;
  snippetsSortDirection: SORT_DIRECTIONS;
  setSnippetsSortDirection: (snippetsSortDirection: SORT_DIRECTIONS) => void;
};

export type Campaign = {
  campaignId: number;
  campaignName: string;
  campaignState: string;
  campaignType: string;
  launchDate: string;
  medium: string;
  mobileAppIds: number[];
  templateId: number;
};

export type CampaignIdToMetadataMap = { [campaignId: string]: Campaign };

export type ThumbnailResp = { [templateId: number]: string };

export type CSVSnippetObj = {
  TotalSent?: number;
  TotalClicks?: number;
  UniqueClicks?: number;
  ClickRate?: number;
  snippetName?: string;
  url?: string;
  dynamicUrl?: string;
  parentSnippet?: string;
  campaignName?: string;
};
